/**
 * @generated SignedSource<<d6bf89d5ac25f8689766aee1f4b43975>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeRecommendedForYouSponsorArticleQueueItemsEdge$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"homeNativeArticleContentItemContent">;
  };
  readonly " $fragmentType": "homeRecommendedForYouSponsorArticleQueueItemsEdge";
};
export type homeRecommendedForYouSponsorArticleQueueItemsEdge$key = {
  readonly " $data"?: homeRecommendedForYouSponsorArticleQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeRecommendedForYouSponsorArticleQueueItemsEdge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "homeRecommendedForYouSponsorArticleQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeNativeArticleContentItemContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "a5586c3fce5de7d0c26582b6c8303f93";

export default node;
